var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.value)?[_vm._v(" - ")]:_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.value),expression:"value"}]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }